import { render } from "./Check.vue?vue&type=template&id=9ed792ae&scoped=true"
const script = {}

import "./Check.vue?vue&type=style&index=0&id=9ed792ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ed792ae"]])

export default __exports__